"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicVehicle = exports.getPublicVehicles = exports.deleteVehicleRelation = exports.postVehicleRelation = exports.putVehicleOrganization = exports.putVehicleAccessibility = exports.deleteVehiclePermission = exports.postVehiclePermission = exports.postVehicle = exports.putVehicle = exports.getVehicle = exports.getVehicles = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var vehiclesAuthorizedPath = root_1.propertyManagementAuthorized + '/vehicles/';
var vehiclesPublicPath = root_1.propertyManagementPublic + '/vehicles/';

var getVehicles = function getVehicles(authentication, queryParameters) {
  return common_1.get(authentication, vehiclesAuthorizedPath, queryParameters);
};

exports.getVehicles = getVehicles;

var getVehicle = function getVehicle(authentication, id) {
  return common_1.get(authentication, vehiclesAuthorizedPath + id);
};

exports.getVehicle = getVehicle;

var putVehicle = function putVehicle(authentication, vehicle) {
  return common_1.put(authentication, vehiclesAuthorizedPath + vehicle.id, vehicle);
};

exports.putVehicle = putVehicle;

var postVehicle = function postVehicle(authentication, vehicle) {
  return common_1.post(authentication, vehiclesAuthorizedPath, vehicle);
};

exports.postVehicle = postVehicle;

var postVehiclePermission = function postVehiclePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, vehiclesAuthorizedPath, id, permission);
};

exports.postVehiclePermission = postVehiclePermission;

var deleteVehiclePermission = function deleteVehiclePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, vehiclesAuthorizedPath, id, permissionId);
};

exports.deleteVehiclePermission = deleteVehiclePermission;

var putVehicleAccessibility = function putVehicleAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, vehiclesAuthorizedPath, id, accessibility);
};

exports.putVehicleAccessibility = putVehicleAccessibility;

var putVehicleOrganization = function putVehicleOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, vehiclesAuthorizedPath, id, accessibility);
};

exports.putVehicleOrganization = putVehicleOrganization;

var postVehicleRelation = function postVehicleRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, vehiclesAuthorizedPath, id, relation);
};

exports.postVehicleRelation = postVehicleRelation;

var deleteVehicleRelation = function deleteVehicleRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, vehiclesAuthorizedPath, id, relationId);
};

exports.deleteVehicleRelation = deleteVehicleRelation;

var getPublicVehicles = function getPublicVehicles(authentication, queryParameters) {
  return common_1.get(authentication, vehiclesPublicPath, queryParameters);
};

exports.getPublicVehicles = getPublicVehicles;

var getPublicVehicle = function getPublicVehicle(authentication, id) {
  return common_1.get(authentication, vehiclesPublicPath + id);
};

exports.getPublicVehicle = getPublicVehicle;